import { Fragment, useCallback, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import IconMarkUp from "../common/IconMarkUp";
import FeatherIconsBody from "./FeatherIconsBody";
import { FeatherIconsTitle, Icons } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const FeatherIconsContainer = () => {
  const [iconTag, setIconTag] = useState({ iconTag: "" });
  const [icon, setIcon] = useState({ featherIcon: "" });
  const [iconFClass, setIconFClass] = useState({ iconFClass: "" });

  const getIconTag = useCallback((tag: string) => {
    setIconTag({
      iconTag: '<i data-feather="' + tag + '"></i>',
    });
    setIcon({
      featherIcon: tag,
    });
    setIconFClass({
      iconFClass: tag,
    });
  }, []);
  return (
    <>
      <Breadcrumbs mainTitle={FeatherIconsTitle} parent={Icons} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={FeatherIconsTitle} />
              <CardBody>
                <FeatherIconsBody getIconTag={getIconTag} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <IconMarkUp iconTag={iconTag} icon={icon} iconFClass={iconFClass} />
    </>
  );
};
export default FeatherIconsContainer;
